import { createWebHistory, createRouter } from "vue-router";
import store from "@/store";
import AuthService from "@/services/auth.service";

// Importa las rutas
import authRoutes from "./routes/auth";
import appRoutes from "./routes/app";

const routes = [
	{
		path: "/",
		name: "RootView",
		component: () => import("@/views/Pages/Home.vue"),
		meta: { requiresAuth: true, allowContentUser: true },
	},
];

routes.push(...authRoutes);
routes.push(...appRoutes);

const router = createRouter({
	history: createWebHistory(),
	routes,
	scrollBehavior(to, from, savedPosition) {
		if (savedPosition) {
			return savedPosition;
		} else {
			return { top: 0 };
		}
	},
});

// Add a global navigation guard to check authentication
router.beforeEach(async (to, from, next) => {
	// La ruta no requiere autenticación, permite el acceso
	if (!to.meta.requiresAuth) {
		return next();
	}

	// Usuario no autenticado, redirige al inicio de sesión
	if (!AuthService.isLoggedIn()) {
		return next({ name: "LoginView" });
	}

	// Carga el usuario actual si no está en el estado de Vuex (p. ej. al recargar la página).
	// Las verificaciones de rol de abajo se aplican también en este caso.
	if (!store.state.auth.user) {
		try {
			await store.dispatch("auth/loadUser");
		} catch (error) {
			console.error("Error loading current user:", error);
		}
		if (!store.state.auth.user) {
			return next({ name: "LoginView" });
		}
	}

	const profileType = store.state.auth.user.data?.profile?.profile_type;

	// Los usuarios de contenidos solo pueden ver Home y Carreras
	if (profileType === "content-user" && !to.meta.allowContentUser) {
		return next({ name: "HomeView" });
	}

	// Si la ruta requiere un OfficeUser, verificamos el tipo de usuario
	if (to.meta.requiresOfficeUser && profileType !== "office-user") {
		return next({ name: "HomeView" });
	}

	// Si la ruta requiere un DelegateUser, verificamos el tipo de usuario
	if (to.meta.requiresDelegateUser && profileType !== "delegate") {
		return next({ name: "HomeView" });
	}

	// Si pasa todas las verificaciones, permite el acceso
	next();
});

export default router;
